import axios from 'axios';

import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { grey } from '@mui/material/colors';

import HeadLine2 from '../common/HeadLine2.js'
import BoxAroundTextField from '../common/BoxAroundTextField.js'
import YearPicker from '../common/YearPicker.js'
import StandardButton from '../common/StandardButton.js'
import copyTableToClipboard from '../utility/copyTableToClipboard.js'

export default function BudgetActual(props) {
  const { token, salesMonth } = props;

  const [amount, setAmount] = useState([]);
  const [total, setTotal] = useState([{
    P1_予算: 0,
    P1_実績: 0,
    P1_達成率: 0,
    P2_予算: 0,
    P2_実績: 0,
    P2_達成率: 0,
    P3_予算: 0,
    P3_実績: 0,
    P3_達成率: 0,
  }]);
  const [startEnabledYear, setStartEnabledYear] = useState(new Date(2024, 1));
  const [endEnabledYear, setEndEnabledYear] = useState(new Date(new Date(props.salesMonth)));
  // const [salesYear, setSalesYear] = useState(new Date(2025, 1));
  const [salesYear, setSalesYear] = React.useState(new Date(props.salesMonth));

  const [alertStatus, setAlertStatus] = useState({
    open: false,
    type: "success",
    message: ""
  });

  useEffect(() => {
    setAlertStatus({
      open: false,
      type: "close",
      message: ""
    });

    // setSalesYear(new Date())
    const year = String(new Date(salesYear).getFullYear());

    let prefectureParam = ''
    const apiURL = process.env.REACT_APP_BASEURL;
    // const getURL = `${apiURL}/data_send/agency_sales_budget_actual?start_month=${startMonth.format('YYYYMM')}`;
    const getURL = `${apiURL}/data_send/agency_sales_budget_actual?start_year=${year}`;

    const rows = new Array(0);

    // setBackdropOpen(true);

    axios({
      method: "GET",
      url:getURL,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(
        response => {

          console.log(response.data);

          console.log(response.data.total);
          console.log(response.data.rows);
          setAmount(response.data.rows)
          setTotal(response.data.total)

          setStartEnabledYear(new Date(response.data.first_year, 1))
          setEndEnabledYear(new Date(response.data.last_year, 1))


        }).catch((error) => {
          // setBackdropOpen(false)
          console.log('axios error')

          if (error.response) {
            setAlertStatus({
              open: true,
              type: "error",
              message: `接続エラー(${error.response.status})`
            });
          } else {
            setAlertStatus({
              open: true,
              type: "error",
              message: `エラー(${error})`
            });
          }
        }
        );
  }, [salesYear])


  return (
    <Box sx={{ p: 4 }}>
      <HeadLine2>
        ■ 予実状況
      </HeadLine2>

      <BoxAroundTextField>
        <YearPicker
          value={salesYear}
          minDate={startEnabledYear}
          maxDate={endEnabledYear}
          onChange={(newValue) => {
            console.log(newValue);
            setSalesYear(new Date(newValue));
          }}
        />

      </BoxAroundTextField>

      <StandardButton variant="contained" color="primary" onClick={() => copyTableToClipboard('budget-table')}>
        クリップボードにコピー
      </StandardButton>

      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table id="budget-table">
          <TableHead>
            <TableRow>
              {/* <TableCell>ID</TableCell> */}
              <TableCell colSpan={2}></TableCell>
              <TableCell colSpan={3} sx={{ backgroundColor: grey[200] }}>P1</TableCell>
              <TableCell colSpan={3} sx={{ backgroundColor: 'backgroud.paper' }}>P2</TableCell>
              {(salesYear.getFullYear() < 2025) &&
                <TableCell colSpan={3} sx={{ backgroundColor: grey[200] }}>P3</TableCell>
              }
              <TableCell colSpan={3} sx={{ backgroundColor: 'backgroud.paper' }}>年間</TableCell>

            </TableRow>
            <TableRow>
              {/* <TableCell>ID</TableCell> */}
              <TableCell>名前</TableCell>
              <TableCell>薬名</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>予算</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>実績</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>達成率</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>予算</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>実績</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>達成率</TableCell>
              {(salesYear.getFullYear() < 2025) &&
                <>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>予算</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>実績</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>達成率</TableCell>
                </>
              }
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>予算</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>実績</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>達成率</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {amount.map((row) => (
              <>
              <TableRow key={row.id}>
                {/* <TableCell>{row.id}</TableCell> */}
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.product_name}</TableCell>
                {/* <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P1_予算}</TableCell> */}
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{salesYear.getFullYear() === 2025 ? '' : row.P1_予算}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P1_実績}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{salesYear.getFullYear() === 2025 ? '' : row.P1_達成率}%</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row.P2_予算}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row.P2_実績}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row.P2_達成率}%</TableCell>
                {(salesYear.getFullYear() < 2025) &&
                  <>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P3_予算}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P3_実績}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P3_達成率}%</TableCell>
                  </>
                }
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{salesYear.getFullYear() === 2025 ? '' : row.合計_予算}</TableCell>
                {/* <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}></TableCell> */}
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row.合計_実績}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{salesYear.getFullYear() === 2025 ? '' : row.年間_達成率}%</TableCell>
                {/* <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>%</TableCell> */}
              </TableRow>

              </>
            ))}
            {total.map((row) => (
              <>
              <TableRow key={row.id}>
                {/* <TableCell>{row.id}</TableCell> */}
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.product_name}</TableCell>
                {/* <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P1_予算}</TableCell> */}
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{salesYear.getFullYear() === 2025 ? '' : row.P1_予算}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P1_実績}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{salesYear.getFullYear() === 2025 ? '' : row.P1_達成率}%</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row.P2_予算}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row.P2_実績}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row.P2_達成率}%</TableCell>
                {(salesYear.getFullYear() < 2025) &&
                  <>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P3_予算}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P3_実績}</TableCell>
                  <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{row.P3_達成率}%</TableCell>
                  </>
                }
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{salesYear.getFullYear() === 2025 ? '' : row.合計_予算}</TableCell>
                {/* <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}></TableCell> */}
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{row.合計_実績}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{salesYear.getFullYear() === 2025 ? '' : row.年間_達成率}%</TableCell>
                {/* <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>%</TableCell> */}
              </TableRow>

              </>
            ))}
            {/* <TableRow>
              <TableCell>合計</TableCell>
              <TableCell>ガラファルド</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{total[0].P1_予算}</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{total[0].P1_実績}</TableCell>
              <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{total[0].P1_達成率}%</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{total[0].P2_予算}</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{total[0].P2_実績}</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{total[0].P2_達成率}%</TableCell>
              {(salesYear.getFullYear() < 2025) &&
                <>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{total[0].P3_予算}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{total[0].P3_実績}</TableCell>
                <TableCell align="right" sx={{ backgroundColor: grey[200] }}>{total[0].P3_達成率}%</TableCell>
                </>
              }
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{total[0].予算計}</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{total[0].実績計}</TableCell>
              <TableCell align="right" sx={{ backgroundColor: 'backgroud.paper' }}>{total[0].年間_達成率}%</TableCell>
            </TableRow> */}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}